import type { JSX } from 'react';
import React from 'react';

import type { BlackbaudRaisersEdgeIntegration } from '@feathr/blackbox';
import type { IIntegrationUIConfig } from '@feathr/components';
import CrmMappingTable from '@feathr/extender/App/Settings/Account/CrmIntegrationPage/CrmMappingTable';
import useRaisersEdgeContactMappings from '@feathr/extender/App/Settings/Account/RaisersEdgeIntegrationPage/useRaisersEdgeContactMappings';

import { BLACKBAUD_ICON } from '../../blackbaudIcon';
import type { IRaisersEdgeMappingDraft } from '../RaisersEdgeMappingsTab.hooks';

interface IProps {
  integration: BlackbaudRaisersEdgeIntegration;
  config: IIntegrationUIConfig;
  draft: IRaisersEdgeMappingDraft;
}

function RaisersEdgeMappingTable({ config, draft, integration }: Readonly<IProps>): JSX.Element {
  // This table owns the mapping load; the page's draft reads the same store.
  const store = useRaisersEdgeContactMappings(integration);

  return (
    <CrmMappingTable
      config={config}
      crmIcon={BLACKBAUD_ICON}
      draft={draft}
      errorName={'raisers-edge-mappings-error'}
      // Rows get `sync-mapping-<Blackbaud field key>`, the v1 e2e name.
      name={'sync-mapping'}
      store={store}
    />
  );
}

export default RaisersEdgeMappingTable;
